// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewSelect-module__dsAccented--I7sUc,.ViewSelect-module__dsAccented--I7sUc *{font-weight:500}.ViewSelect-module__dsDefaultWeight--wAl7k,.ViewSelect-module__dsDefaultWeight--wAl7k *{font-weight:400}h5.ViewSelect-module__dsAccented--I7sUc,h5.ViewSelect-module__dsAccented--I7sUc *{font-weight:700}.ViewSelect-module__dsUnderline--SGMI9,.ViewSelect-module__dsUnderline--SGMI9 *{text-decoration:underline}.ViewSelect-module__dsAccented2--ktMxC,.ViewSelect-module__dsAccented2--ktMxC *{font-weight:700}.ViewSelect-module__dsBodyXL--LOnLc,.ViewSelect-module__dsBodyXL--LOnLc *{font-size:18px;line-height:27px}.ViewSelect-module__dsBodyLarge--kXjMe,.ViewSelect-module__dsBodyLarge--kXjMe *{font-size:16px;line-height:24px}.ViewSelect-module__dsBody--MkXq8,.ViewSelect-module__dsBody--MkXq8 *{font-size:14px;line-height:20px}.ViewSelect-module__dsBodySmall--vXn9Z,.ViewSelect-module__dsBodySmall--vXn9Z *{font-size:12px;line-height:18px}.ViewSelect-module__dsBodyXS--ZkKrL,.ViewSelect-module__dsBodyXS--ZkKrL *{font-size:10px;line-height:15px}.ViewSelect-module__dsActionLarge--C8Np3,.ViewSelect-module__dsActionLarge--C8Np3 *{font-size:16px;line-height:18px}.ViewSelect-module__dsAction--GYD_W,.ViewSelect-module__dsAction--GYD_W *{font-size:14px;line-height:16px}.ViewSelect-module__dsActionSmall--KcFGX,.ViewSelect-module__dsActionSmall--KcFGX *{font-size:12px;line-height:14px}.ViewSelect-module__dsColumnHeadLine--wgTJ9,.ViewSelect-module__dsColumnHeadLine--wgTJ9 *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.ViewSelect-module__dsLightXL--s91Cq,.ViewSelect-module__dsLightXL--s91Cq *{font-size:120px;line-height:160px;font-weight:300}.ViewSelect-module__dsLightLarge--zCj7R,.ViewSelect-module__dsLightLarge--zCj7R *{font-size:48px;line-height:64px;font-weight:300}.ViewSelect-module__dsLight--looRV,.ViewSelect-module__dsLight--looRV *{font-size:32px;line-height:64px;font-weight:300}.ViewSelect-module__dsLightSmall--jZkij,.ViewSelect-module__dsLightSmall--jZkij *{font-size:24px;line-height:36px;font-weight:300}.ViewSelect-module__dsLightXS--kGD8x,.ViewSelect-module__dsLightXS--kGD8x *{font-size:18px;line-height:27px;font-weight:300}.ViewSelect-module__viewSelectorContainer--U_nX7{translate:-2px 8px;box-shadow:0px 0px 4px 0px rgba(0,0,0,.2509803922);width:300px}.ViewSelect-module__viewIndicator--qp2rC{position:relative;top:-5px;width:6px;height:6px;margin-left:4px;border-radius:50%;background:#f14668;display:inline-block}:disabled .ViewSelect-module__viewIndicator--qp2rC{display:none}.ViewSelect-module__viewBtnPrefix--iPZuc{color:#7c7fd2;margin-right:4px}:disabled .ViewSelect-module__viewBtnPrefix--iPZuc{color:#b3b9c8}div.ViewSelect-module__optionSettingsContainer--stvIe{translate:0px 6px;width:240px}.ViewSelect-module__optionDefaultIcon--_bfz5 svg:not(:root){color:#00d41f;width:14px;height:14px}.ViewSelect-module__optionContainer--WYvaR:hover div:has(>.ViewSelect-module__optionDefaultIcon--_bfz5):has(+.ViewSelect-module__optionSettingsWrapper--ihBS4) .ViewSelect-module__optionDefaultIcon--_bfz5{display:none}div:has(>.ViewSelect-module__optionDefaultIcon--_bfz5):has(+.ViewSelect-module__optionSettingsWrapper--ihBS4.isActive) .ViewSelect-module__optionDefaultIcon--_bfz5{display:none}.ViewSelect-module__optionSettingsWrapper--ihBS4{margin-right:4px}.ViewSelect-module__optionSettingsWrapper--ihBS4:not(.isActive){display:none}.ViewSelect-module__optionContainer--WYvaR:hover .ViewSelect-module__optionSettingsWrapper--ihBS4:not(.isActive){display:block}.ViewSelect-module__autogenStatusInfo--YE6z9{display:inline-block;line-height:18px;height:auto;position:relative;top:2px}.ViewSelect-module__autogenStatusInfo--YE6z9 svg:not(:root){width:12px;height:12px;color:#8c95a8;display:block}.ViewSelect-module__autogenStatusInfo--YE6z9:hover svg{color:#5155f5}.ViewSelect-module__autogenBottomContainer--FWawp{display:flex;gap:8px}.ViewSelect-module__formContainer--vnmV1{display:flex;flex-direction:column;gap:12px;width:340px}.ViewSelect-module__field--BT7ck{display:flex;flex-direction:column;gap:10px}.ViewSelect-module__fieldLabel--qjO43{color:#5f677e;font-size:14px}.ViewSelect-module__toggle--akLgm{display:flex;gap:10px;align-items:center}.ViewSelect-module__toggle--akLgm label{font-weight:normal}.ViewSelect-module__deleteViewModalContent--LGfwS{text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `ViewSelect-module__dsAccented--I7sUc`,
	"dsDefaultWeight": `ViewSelect-module__dsDefaultWeight--wAl7k`,
	"dsUnderline": `ViewSelect-module__dsUnderline--SGMI9`,
	"dsAccented2": `ViewSelect-module__dsAccented2--ktMxC`,
	"dsBodyXL": `ViewSelect-module__dsBodyXL--LOnLc`,
	"dsBodyLarge": `ViewSelect-module__dsBodyLarge--kXjMe`,
	"dsBody": `ViewSelect-module__dsBody--MkXq8`,
	"dsBodySmall": `ViewSelect-module__dsBodySmall--vXn9Z`,
	"dsBodyXS": `ViewSelect-module__dsBodyXS--ZkKrL`,
	"dsActionLarge": `ViewSelect-module__dsActionLarge--C8Np3`,
	"dsAction": `ViewSelect-module__dsAction--GYD_W`,
	"dsActionSmall": `ViewSelect-module__dsActionSmall--KcFGX`,
	"dsColumnHeadLine": `ViewSelect-module__dsColumnHeadLine--wgTJ9`,
	"dsLightXL": `ViewSelect-module__dsLightXL--s91Cq`,
	"dsLightLarge": `ViewSelect-module__dsLightLarge--zCj7R`,
	"dsLight": `ViewSelect-module__dsLight--looRV`,
	"dsLightSmall": `ViewSelect-module__dsLightSmall--jZkij`,
	"dsLightXS": `ViewSelect-module__dsLightXS--kGD8x`,
	"viewSelectorContainer": `ViewSelect-module__viewSelectorContainer--U_nX7`,
	"viewIndicator": `ViewSelect-module__viewIndicator--qp2rC`,
	"viewBtnPrefix": `ViewSelect-module__viewBtnPrefix--iPZuc`,
	"optionSettingsContainer": `ViewSelect-module__optionSettingsContainer--stvIe`,
	"optionDefaultIcon": `ViewSelect-module__optionDefaultIcon--_bfz5`,
	"optionContainer": `ViewSelect-module__optionContainer--WYvaR`,
	"optionSettingsWrapper": `ViewSelect-module__optionSettingsWrapper--ihBS4`,
	"autogenStatusInfo": `ViewSelect-module__autogenStatusInfo--YE6z9`,
	"autogenBottomContainer": `ViewSelect-module__autogenBottomContainer--FWawp`,
	"formContainer": `ViewSelect-module__formContainer--vnmV1`,
	"field": `ViewSelect-module__field--BT7ck`,
	"fieldLabel": `ViewSelect-module__fieldLabel--qjO43`,
	"toggle": `ViewSelect-module__toggle--akLgm`,
	"deleteViewModalContent": `ViewSelect-module__deleteViewModalContent--LGfwS`
};
module.exports = ___CSS_LOADER_EXPORT___;
